import { AlertTriangle } from 'lucide-react';
import { Link } from 'react-router-dom';

import { useSyncStore } from '../../../stores/sync-store.js';

/**
 * Persistent banner that surfaces whenever the offline sync queue
 * contains unresolved conflicts. Lives at the top of the org layout
 * so it can't be missed on the way back to the device.
 */
export function SyncConflictBanner() {
  const conflictCount = useSyncStore((s) => s.conflictCount);
  if (conflictCount <= 0) return null;
  return (
    <div
      role="alert"
      className="flex items-center justify-between gap-3 border-b border-danger/40 bg-danger/10 px-4 py-2 text-sm text-danger"
    >
      <div className="flex items-center gap-2">
        <AlertTriangle className="h-4 w-4" />
        <span>
          {conflictCount === 1
            ? '1 sync conflict needs your attention'
            : `${conflictCount} sync conflicts need your attention`}
        </span>
      </div>
      <Link
        to="/sync/conflicts"
        className="rounded-md border border-danger/40 px-2.5 py-1 text-xs font-semibold uppercase tracking-wide hover:bg-danger/10"
      >
        Review
      </Link>
    </div>
  );
}
